import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../helper/icon/icon.component';

export interface ScriptSubmissionErrorData {
  message: string;
  errorMessages: string[];
  errors?: string; // Legacy format for backwards compatibility
}

@Component({
  selector: 'app-script-submission-error',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    ClipboardModule,
    IconComponent
  ],
  templateUrl: './script-submission-error.component.html',
  styleUrl: './script-submission-error.component.less'
})
export class ScriptSubmissionErrorComponent {
  copied = false;

  constructor(
    public dialogRef: MatDialogRef<ScriptSubmissionErrorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ScriptSubmissionErrorData
  ) {}

  get errorText(): string {
    if (this.data.errorMessages && this.data.errorMessages.length > 0) {
      return this.data.errorMessages.join('\n');
    }
    // Fallback to legacy format
    if (this.data.errors) {
      return this.data.errors.replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]*>/g, '');
    }
    return this.data.message;
  }

  copyErrors() {
    const textToCopy = `Script Submission Errors:\n\n${this.errorText}`;
    navigator.clipboard.writeText(textToCopy).then(() => {
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 2000);
    });
  }
}

